import styled from 'styled-components';

import { Menu } from '@xing-com/menu';
import { spaceM } from '@xing-com/tokens';

export const RightSocialMenu = styled(Menu)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${spaceM};
`;
